import type { FC } from 'react';

import { SectionLoader } from '@/shared/components/section-loader';

import { useWhatsappTemplatesTranslations } from '../hooks/use-translations';

type TRouteLoadingProps = {
  className: string;
};

const RouteLoading: FC<TRouteLoadingProps> = ({ className }) => {
  const { t } = useWhatsappTemplatesTranslations();

  return (
    <div
      role="status"
      aria-label={t('ROUTE_LOADING_LABEL')}
      className={className}
    >
      <SectionLoader />
    </div>
  );
};

export const WhatsappTemplatesPageLoading: FC = () => {
  return <RouteLoading className="tw-h-screen tw-w-full" />;
};

export const WhatsappTemplatesSectionLoading: FC = () => {
  return <RouteLoading className="tw-h-[50vh] tw-w-full" />;
};
